import { create } from 'zustand';

export type OrderPlacedDialogPayload = {
  purchaseOrderId: string;
  poNumber?: string;
  supplierEmail?: string;
  supplierName?: string;
  supplierPhone?: string;
  supplierWebsite?: string;
  supplierAddressLine?: string;
};

interface OrderPlacedDialogState {
  payload: OrderPlacedDialogPayload | null;
  open: (payload: OrderPlacedDialogPayload) => void;
  close: () => void;
}

export const useOrderPlacedDialogStore = create<OrderPlacedDialogState>((set) => ({
  payload: null,
  open: (payload) => set({ payload }),
  close: () => set({ payload: null }),
}));
